import { RUNTIME_IS_SERVER } from "~/env";

import { loggerService } from "./logger.service";

const permissionDefaultState = "default";
const permissionGrantedState = "granted";

const requestNotificationsPermission = async () => {
  if (!RUNTIME_IS_SERVER && !window.Notification) {
    loggerService.warn("Notification interface not available");
    return;
  }

  if (Notification.permission === permissionDefaultState) {
    const permission = await Notification.requestPermission();
    if (permission !== permissionGrantedState) {
      loggerService.warn("Notification permission denied");
    }
    return;
  }

  if (Notification.permission === permissionGrantedState) {
    return;
  }
  loggerService.warn("Notification permission denied.");
};

const triggerNotification = async (title: string, message: string, onClick?: (e: Event) => void): Promise<void> => {
  try {
    await requestNotificationsPermission();
    const notification = new Notification(title, {
      body: message,
      icon: "/favicon/favicon-32x32.png",
    });
    if (!!onClick) {
      notification.onclick = event => {
        event.preventDefault();
        onClick(event);
      };
    }
  } catch (err) {
    loggerService.error("Failed to send Notification", err as Error);
  }
};

export const notificationsService = (() => ({
  requestNotificationsPermission,
  triggerNotification,
}))();
